module.exports = __webpack_public_path__ + "static/media/savings.214c41a7.svg";